"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgHot = function SvgHot(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.814 6.254c-.19-.295-.662-.227-.84.076-.16.266-.356.509-.587.718a.25.25 0 0 1-.34-.006C14.463 5.564 13.165 3.086 12.96.837c-.036-.422-.535-.692-.877-.443-3.965 2.891-8.688 6.899-8.688 12.083 0 5.183 4.094 9.182 8.517 9.182 3.743 0 7.997-2.44 8.573-6.887.415-3.21-1.01-5.952-2.669-8.518Zm-1.137 7.325c-.048.376-.576.41-.585-.03-.02-1.18-.505-1.978-1.058-2.57-.159-.17-.453-.053-.519.171-.245.842-.956 1.655-1.856 1.533-1.174-.159-2.343-1.265-2.744-1.679-.089-.09-.274-.102-.358-.01-.175.19-.448.582-.748 1.457-.258.76-.28 1.606-.152 2.404.06.354-.41.528-.597.222-.463-.757-.787-1.719-.864-2.919-.195-3.103 2.152-5.534 3.335-6.423.186-.141.442-.005.451.228.102 2.633 1.736 5.734 3.734 3.29.09-.11.26-.081.371.011 1.269 1.07 1.799 2.652 1.588 4.315h.002Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgHot);
var _default = exports["default"] = Memo;